import * as _ from "lodash";
import { connect } from "react-redux";

import actions from "@/actions";

import Edit from "./Edit";

const mapStateToProps = ({ map }) => ({
    mapSettings: _.cloneDeep(map.general.settings),
});
const mapDispatchToProps = {
    save: actions.map.general.saveSettings,
    deselectAllLights: actions.map.general.deselectAllLights,
};
export default connect(mapStateToProps, mapDispatchToProps)(Edit);
